<template>
    <div class="breadcrumbs__container">
        <div
            class="flex justify-content-between flex-column sm:flex-row sm:align-items-center flex-wrap breadcrumbs__content"
            data-pc-section="content"
            v-bind="getPT('content')"
        >
            <Breadcrumb
                :home="home"
                :model="model.breadcrumbs"
                class="flex-order-2 sm:flex-order-1 py-2"
                :pt="{action: {class: 'inline'}}"
            />
            <div class="flex-order-1 sm:flex-order-2 mb-2 sm:mb-0">
                <div class="flex justify-content-end flex-wrap gap-3">
                    <slot></slot>
                    <template v-if="helpUrl">
                        <Button
                            :label="$t('lang.main.help_title')"
                            text
                            @click="onHelp"
                            class="p-button-extra-sm"
                            severity="secondary"
                            icon="pi pi-info-circle"
                            :pt="{
                                icon: {class: 'mr-0 sm:mr-2'},
                                label: {class: 'hidden sm:inline'},
                            }"
                        />
                    </template>
                    <template v-if="videoName">
                        <Button
                            :label="$t('lang.main.youtube_instruction')"
                            text
                            @click="onOpenVideo"
                            class="p-button-extra-sm"
                            severity="secondary"
                            icon="pi pi-video"
                            :pt="{
                                icon: {class: 'mr-0 sm:mr-2'},
                                label: {class: 'hidden sm:inline'},
                            }"
                        />
                        <BreadcrumbsVideo :videoName="videoName" :youtubeId="youtubeId" :rutubeId="rutubeId" />
                    </template>
                    <template v-if="useDiscussTg">
                        <Button
                            :label="$t('lang.main.discuss_to_tg')"
                            text
                            @click="onDiscussToTg"
                            class="p-button-extra-sm"
                            severity="secondary"
                            icon="pi pi-send"
                            :pt="{
                                icon: {class: 'mr-0 sm:mr-2'},
                                label: {class: 'hidden sm:inline'},
                            }"
                        />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "primevue/breadcrumb";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import {Listeners} from "../../constants/listeners";
import BreadcrumbsVideo from "./Video.vue";
import PassThrough from "../../mixins/PassThrough";

export default {
    name: "BlockBreadcrumbs",
    mixins: [PassThrough],
    props: {
        useDiscussTg: {
            type: Boolean,
            default: false,
        },
        videoName: {
            type: String,
            default: null,
        },
        helpUrl: {
            type: String,
            default: null,
        },
        breadcrumbs: {
            type: Array,
            required: true
        },
        youtubeId: {
            type: String,
            required: false,
            default: null,
        },
        rutubeId: {
            type: String,
            required: false,
            default: null,
        },
    },
    mounted() {
        this.model.breadcrumbs = this.breadcrumbs;
        this.$emitter.on(Listeners.BLOCK_BREADCRUMBS_LAST_ITEM_RENAME, name => this.renameLastItem(name));
    },
    data() {
        return {
            home: {
                icon: 'pi pi-home',
                url: sprintf('/%s/', window.locale),
            },
            model: {
                breadcrumbs: [],
            },
        };
    },
    methods: {
        onDiscussToTg() {
            window.open(this.$t('lang.main.keysso_talk'));
        },
        onHelp() {
            window.open(this.helpUrl);
        },
        onOpenVideo() {
            this.$emitter.emit(Listeners.BLOCK_BREADCRUMBS_VIDEO_OPEN);
        },
        renameLastItem(name) {
            let lastItem = this.model.breadcrumbs.pop();
            lastItem.label = name;
            this.model.breadcrumbs.push(lastItem);
        },
    },
    components: {
        Breadcrumb,
        Button,
        Dialog,
        BreadcrumbsVideo,
    }
}
</script>

<style scoped>
.breadcrumbs__container {
    background-color: var(--surface-b);
    border-bottom: 1px solid var(--gray-200);
}
.breadcrumbs__content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0.3125rem 0;
}
.tablereports .breadcrumbs__content {
    max-width: 1500px;
}
:deep(.p-breadcrumb) {
    font-size: 0.8125rem;
    line-height: 0.8125rem;
    border: 0;
    background-color: var(--surface-b);
}
:deep(.p-menuitem-separator .pi) {
    font-size: 0.8125rem;
}
:deep(.p-breadcrumb-list) .p-menuitem span {
    color: var(--keysso-secondary-color-2) !important;
}
:deep(.p-breadcrumb-list) .p-menuitem:not(:last-of-type) span,
:deep(.p-breadcrumb-list) li svg {
    color: var(--secondary-color) !important;
    height: 0.8125rem;
    font-size: 0.8125rem;
}
:deep(.p-breadcrumb-list) li svg {
    height: 0.65rem;
}
.p-button {
    box-shadow: none !important;
}
:deep(.p-button) .p-button-label {
    font-weight: 400 !important;
    color: var(--keysso-secondary-color-2) !important;
}
:deep(.p-breadcrumb-list) .p-disabled {
    opacity: 1;
}
</style>
